import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';
import MenuIcon from '@material-ui/icons/Menu';
import MoreIcon from '@material-ui/icons/MoreVert';
import HomeIcon from '@material-ui/icons/Home';
import AccountCircle from '@material-ui/icons/AccountCircle';
import PublicIcon from '@material-ui/icons/Public';
import HelpIcon from '@material-ui/icons/Help';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import LogoutIcon from '@material-ui/icons/ExitToApp';
import LogoUnicef from '../images/white_logo.png'
import {
    Translation
} from '../features/translations/getTranslation'
import { useHistory } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
    grow: {
        flexGrow: 1,
    },
    buttonMobile: {
        color: '#FFF',
        border: 'none',
        margin: '0 auto',
        padding: '0 10px'
    },
    buttonDesktop: {
        color: '#FFF',
        border: 'none'
    },
    sectionDesktop: {
        display: 'none',
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
        },
    },
    sectionMobile: {
        display: 'flex',
        [theme.breakpoints.up('sm')]: {
            display: 'none',
        },
    },
}))

export const Navbar = () => {
    const classes = useStyles()
    const [anchorEl, setAnchorEl] = React.useState(null)
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null)

    const isMenuOpen = Boolean(anchorEl)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)

    const handleProfileMenuOpen = (event) => {
        setAnchorEl(event.currentTarget)
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null)
    };

    const handleMenuClose = () => {
        setAnchorEl(null)
        handleMobileMenuClose()
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget)
    };

    const history = useHistory()
    const goToLink = (e) => {
        e.preventDefault()
        if (typeof e.currentTarget.attributes.href.value !== 'undefined') {
            history.push(e.currentTarget.attributes.href.value)
        } else if (typeof e.target.parentElement.attributes.href.value !== 'undefined') {
            history.push(e.target.parentElement.attributes.href.value)
        }
        else console.log("link not found")
    }

    const [opened, setOpened] = React.useState(history.location.pathname)

    const handleOpened = (event, newOpened) => {
        if (newOpened) setOpened(newOpened)
        else newOpened = opened
        history.push(newOpened)
    };

    const menuId = 'primary-search-account-menu'
    const renderMenu = (
        <Menu
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={menuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMenuOpen}
            onClose={handleMenuClose}
        >
            {/*<MenuItem onClick={(e) => { handleMenuClose(); goToLink(e); }} href="/profile">*/}
            {/*    <IconButton*/}
            {/*        aria-label="account of current user"*/}
            {/*        aria-controls="primary-search-account-menu"*/}
            {/*        aria-haspopup="true"*/}
            {/*        color="inherit"*/}
            {/*    >*/}
            {/*        <AccountCircle />*/}
            {/*    </IconButton>*/}
            {/*    <p>{Translation.t("PASSWORD")}</p>*/}
            {/*</MenuItem>*/}
            <MenuItem onClick={(e) => { handleMenuClose(); goToLink(e); }} href="/userlanguage">
                <IconButton
                    aria-label="language of current user"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <PublicIcon />
                </IconButton>
                <p>{Translation.t("USER_LANGUAGE")}</p>
            </MenuItem>
            <MenuItem onClick={(e) => { handleMenuClose(); goToLink(e); }} href="/help">
                <IconButton
                    aria-label="help"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <HelpIcon />
                </IconButton>
                <p>{Translation.t("HELP")}</p>
            </MenuItem>
            <MenuItem onClick={(e) => { handleMenuClose(); window.open('/Version/DownloadFinalisedPdf', '_blank'); }}>
                <IconButton
                    aria-label="application_guide"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <PictureAsPdfIcon />
                </IconButton>
                <p>{Translation.t("APPLICATION_GUIDE")}</p>
            </MenuItem>
            <MenuItem onClick={goToLink} href="/logout">
                <IconButton
                    aria-label="logout"
                    aria-controls="primary-search-account-menu"
                    aria-haspopup="true"
                    color="inherit"
                >
                    <LogoutIcon />
                </IconButton>
                <p>{Translation.t("LOGOUT")}</p>
            </MenuItem>
        </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile'

    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
        >
            <MenuItem onClick={(e) => { setOpened('/active'); handleMobileMenuClose(); goToLink(e) }} href="/active">
                <IconButton aria-label="go home" color="inherit">
                    <HomeIcon />
                </IconButton>
                <p>{Translation.t("HOME")}</p>
            </MenuItem>
            <MenuItem onClick={handleProfileMenuOpen}>
                <IconButton aria-label="more options" aria-controls="more-options-menu" aria-haspopup="true" color="inherit">
                    <MoreIcon />
                </IconButton>
                <p>{Translation.t("MORE_OPTIONS")}</p>
            </MenuItem>
        </Menu>
    )

    return (
        <div className={classes.grow}>
            <AppBar position="fixed">
                <Toolbar>
                    <div onClick={(e) => { setOpened('/active'); goToLink(e) }} href="/active">
                        <img src={LogoUnicef} alt="Unicef" />
                    </div>
                    <div className={classes.grow} />
                    <div className={classes.sectionDesktop}>
                        <ToggleButtonGroup variant="text" exclusive value={opened} onChange={handleOpened} aria-label="desktop button group">
                            <ToggleButton value="/active" className={classes.buttonDesktop}>{Translation.t("ACTIVE")}</ToggleButton>
                            <ToggleButton value="/pending" className={classes.buttonDesktop}>{Translation.t("PENDING")}</ToggleButton>
                            < ToggleButton value="/history" className={classes.buttonDesktop} > {Translation.t("HISTORY")}</ToggleButton>
                        </ToggleButtonGroup>
                        <IconButton
                            edge="end"
                            aria-label="User Profile"
                            aria-controls={menuId}
                            aria-haspopup="true"
                            onClick={handleProfileMenuOpen}
                            color="inherit"
                        >
                            <MoreIcon />
                        </IconButton>
                    </div>
                    <div className={classes.sectionMobile}>
                        <IconButton
                            aria-label="show more"
                            aria-controls={mobileMenuId}
                            aria-haspopup="true"
                            onClick={handleMobileMenuOpen}
                            color="inherit"
                        >
                            <MenuIcon />
                        </IconButton>
                    </div>
                </Toolbar>
                <Toolbar position="fixed" className={classes.sectionMobile}>
                    <ToggleButtonGroup variant="text" exclusive value={opened} onChange={handleOpened} aria-label="mobile button group" className="w-100">
                        <ToggleButton value="/active" className={classes.buttonMobile}>Active</ToggleButton>
                        <ToggleButton value="/pending" className={classes.buttonMobile}>Pending</ToggleButton>
                        <ToggleButton value="/history" className={classes.buttonMobile}>History</ToggleButton>
                    </ToggleButtonGroup>
                </Toolbar>
            </AppBar>
            {renderMobileMenu}
            {renderMenu}
        </div>
    )
}

export default Navbar